<template>
  <div>

  </div>
</template>


<script>


export default {
  components: {

  },
  data() {
    return {
    };
  },
  mounted: function () {
    
  },
  methods: {
  },
};
</script>


<style>
@import "//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css";
</style>
